import { arrondir } from "../../librairie";

export function getOperation(theme, siarrondir = false) {
    var operation = "";
    if (theme) {

        if (siarrondir) {
            operation = theme.signe === "inf" ? "<=" : ">=";
            operation += (theme.valeurtest === "Saisie") ?
                arrondir(parseFloat(theme.valeursaisie)) :
                arrondir(parseFloat(theme.valeurtest));
        }
        else {
            operation = {}
            operation.signe = theme.signe === "inf" ? "<=" : ">=";
            operation.valeur = theme.valeurtest === "Saisie" ?
                parseFloat(theme.valeursaisie) :
                parseFloat(parseFloat(theme.valeurtest));
        }

    }
    return operation;
}